import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'

import type { GetPropertyType } from '../../../types/GetProperty'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    padding 8px;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface PropertiesProps {
    properties: GetPropertyType[]
}

const Properties: React.FC<PropertiesProps> = ({ properties }) => {

    return (
        <ThemeProvider theme={theme} >
            {
                properties.map((property, index) => (
                    <Table key={index} cellPadding="0" cellSpacing="0">
                        <tbody>
                            <HeaderRow>
                                <td>PROPERTY</td>
                            </HeaderRow>
                            <tr>
                                <td>
                                    <Table key={index} cellPadding="2" cellSpacing="0">
                                        <tbody>
                                            <tr>
                                                <TableCell>
                                                    <Label>Involvement</Label>
                                                    {property && property.involvement ? property.involvement : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Article</Label>
                                                    {property && property.description ? property.description : '\u00A0'}
                                                </TableCell>
                                                <TableCell width="100%">
                                                    &nbsp;
                                                </TableCell>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                ))
            }
        </ThemeProvider>
    );
}

export default Properties;